import { statusLights, globalDefines } from './../../app/app.constants';
import { UserProvider } from './../../providers/user/user';
import { Component } from '@angular/core';
import { IonicPage, Platform, NavController, ToastController } from 'ionic-angular';
import { dynamicSort, GlobalVars } from '../../app/app.environment';
import { DatePipe } from '@angular/common';


@IonicPage()
@Component({
  selector: 'page-users-status',
  templateUrl: 'users-status.html',
})
export class UsersStatusPage {
  
  allUsers: any[];
  users: any[];
  usersSubscription;
  search: string;

  sort = {
    name: 'asc',
    state: 'none'
  }

  lastFieldSorted = 'name'
  statusLights = statusLights;
  workTime = [];

  mobilePlatform

  constructor(
    private datePipe: DatePipe,
    private navCtrl: NavController,
    private platform: Platform,
    private toastCtrl: ToastController,
    public globalVars: GlobalVars,
    private userProvider: UserProvider
  ) {
    this.mobilePlatform = (this.platform.is('mobile') || this.platform.is('mobileweb')) && !this.platform.is('tablet')
  }

  ionViewDidEnter() {
    this.usersSubscription = this.userProvider.getUsers().subscribe(users => {
      this.allUsers = users.filter(user => user.role != 3)
      this.users = this.allUsers
      this.applyOrder()
      this.calculateWorkTime()
    });
  }

  ionViewWillUnload() {
    if(this.usersSubscription && !this.usersSubscription.closed) this.usersSubscription.unsubscribe()
  }

  getLastCheckState(user): string {
    return user.lastCheck != null ? (user.lastCheck.type + ' -- ' + user.lastCheck.workplace) : null
  }

  getLastCheckInfo(user): string {
    let date = user.lastCheck != null ? user.lastCheck.timestamp : null;
    let formattedDate = this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss')

    if (user.lastCheck != null) {
      if (user.lastCheck.delayString != null) return formattedDate + ' -- ' + user.lastCheck.delayString
      else return formattedDate
    }

    else return ''
  }

  searchCancel() {
    this.users = this.allUsers;
  }

  searchItems(ev: any) {
    this.users = this.allUsers.filter(user => user.name.toLowerCase().indexOf(ev.target.value.toLowerCase()) > -1)
  }

  ubication(check) {
    if(check && check.coords) {
      this.navCtrl.push('MapPage', { mode: 'check', check: check });
    }

    else this.showMessage(`No es posible mostrar la ubicación del último fichaje.`);
  }

  reorder(field: string) {    
    if (this.sort[field] == 'asc') {
      this.sort[field] = 'desc'
    }

    else {
      this.sort[field] = 'asc'
    }

    this.lastFieldSorted = field
    console.log(this.sort)

    this.applyOrder()
  }

  private applyOrder() {
    if (this.lastFieldSorted == 'name') {
      this.orderByField('state', this.sort.state)
      this.orderByField('name', this.sort.name)
    }

    else {
      this.orderByField('name', this.sort.name)
      this.orderByField('state', this.sort.state)
    }
  }

  private orderByField(field: string, orderType: string) {
    this.users = this.users.sort(dynamicSort(field))

    if(orderType == 'desc') this.users = this.users.reverse()
  }

  private calculateWorkTime() {
    this.users.forEach(user => {
      if(user.lastCheck) {
        user.lastCheck.timestamp
        user.workTime = msToTime(user.lastCheck.timestamp - new Date().getTime())
      }
    })

    setTimeout(() => this.calculateWorkTime(), 60000)
  }

  private showMessage(message: string) {
    this.toastCtrl.create({message: message, duration: globalDefines.defaultToastDuration}).present();
  }
}

/**
 * Obtenir un string amb hores, minuts i segons a partir de uns milisegons donats.
 * 
 * @param ms Milisegons
 */
function msToTime(ms): string {

  ms = Math.abs(ms);

  var h, m, s;
  s = Math.floor(ms / 1000);
  m = Math.floor(s / 60);
  s = s % 60;
  h = Math.floor(m / 60);
  m = m % 60;

  var result = ''
  if(ms < 60000) result = s + ' seg';
  
  else {
    if(m >= 0) result = m + ' min' + result;
    if(h > 0) result = h + ' h, ' + result;
  }

  return result;
}


// WEBPACK FOOTER //
// ./src/pages/users-status/users-status.ts